import React from "react";
import "./Input.css";

const Input = ({ className = "", ...rest }) => (
  <input className={`app-input ${className}`} {...rest} />
);

export default Input;
